<template>
  <div class="list-rest">
    <VouteCounter
      :votesAll="numberOfVotesCast"
      :votesDone="numberOfUsedVotes"
      v-on:sendVotes="sendAllVotes"
      v-if="!indexOfStart && numberOfVotesCast && canVote"
    />
    <div
      class="list-rest__list"
      v-for="(listItem, index) in arrayElements"
      :key="index"
    >
      <div
        class="list-rest__waiting-room"
        v-if="showWaitingRoom(listItem, index)"
        ref="waiting"
        tabindex="0"
        aria-label="Poczekalnia"
      >
        {{ listDivide[1].name }}
      </div>
      <div
        class="list-rest__waiting-room"
        v-if="showLucky13(listItem, index)"
        tabindex="0"
        ref="lucky13"
        aria-label="Szczęśliwa trzynastka"
      >
        {{ listDivide[2].name }}
      </div>
      <div
        class="list-rest__single-list-element"
        v-if="showFirstElement(listItem)"
        :class="{ mainList: mainList, voted: !indexOfStart && (listItem.isAlreadyVoted || votedBefore.includes(listItem.id))}"
      >
        <div
          class="list-rest__index" 
          :class="{
            secondFirst: listItem.position === 1,
            voteAdded: listItem.voteAdded
          }"
          v-if="listItem.position"
          tabindex="0"
          :aria-label="'Miejsce numer' + listItem.position"
        >
          {{ listItem.position }}
        </div>
        <div
          class="list-rest__index"
          :class="{ voteAdded: (listItem.voteAdded && !votedBefore.includes(listItem.id)) }"
          v-if="!listItem.position"
          tabindex="0"
          :aria-label="'Numer' + (index + 1)"
        >
          {{ index + 1 }}
        </div>
        <div
          class="list-rest__photo"
          v-if="indexOfStart && listNumber !== '11'"
        >
          <div
            class="list-rest__photo-content"
            :class="{ photoContentWithoutPhoto: !listItem.artists[0].photo }"
            v-bind:style="{
              backgroundImage: 'url(' + listItem.artists[0].photo + ')'
            }"
          >
            <div
              class="list-rest__photo-content-new"
              v-if="listItem.isNew && listNumber !== '11'"
            >
              nowość
            </div>
          </div>
        </div>
        <div
          class="list-rest__info"
          :style="{ width: canVote ? '45%' : '68%' }"
        >
          <div
            ref="contentContainers"
            class="list-rest__info-content"
            :class="{specialNote: special}"
            :style="{ width: mainList ? '80%' : '80%' }"
          >
            <div class="list-rest__song-info">
              <div
                class="list-rest__info-artist"
                @click="
                  () => {
                    goToArtistSite(listItem.artists[0].id);
                  }
                "
                v-on:keyup.enter="
                  () => {
                    goToArtistSite(listItem.artists[0].name);
                  }
                "
                tabindex="0"
                :aria-label="listItem.artists[0].name"
              >
                <p v-if="listItem.artists[0].displayedName && !indexOfStart">
                  {{ listItem.artists[0].displayedName }}
                </p>
                <p v-else ref="artistNames">{{ listItem.artists[0].name }}</p>
              </div>
              <div class="list-rest__info-title">
                <p
                ref="songTitles"
                  @click="
                    () => {
                      goToSong(listItem.id);
                    }
                  "
                  v-on:keyup.enter="
                    () => {
                      goToSong(listItem.id);
                    }
                  "
                  tabindex="0"
                  :aria-label="listItem.name"
                >
                  {{ listItem.name }}
                </p>
              </div>
            </div>
            

            <div :class='["list-rest__info-button", {"list-rest__info-button--waitingList" : (listItem.position > 30 && listItem.position < 51) && (listDivide &&
                    listDivide[1])}]'
            v-if="!(listItem.position > 50) || listNumber!=1"
                    >
              <div
                class="list-rest__statistic-box"
                v-if="
                  (listDivide &&
                    listDivide[1] &&
                    index <
                      listDivide[0].numberOfSongs +
                        listDivide[1].numberOfSongs &&
                    indexOfStart) ||
                    indexOfStart && !special
                "
              >
                <div
                  tabindex="0"
                  :aria-label="'ostatnia pozycja' + listItem.lastPosition"
                >
                  Ostatnio
                </div>
                <p>{{ listItem.lastPosition }}</p>
              </div>
              <div
                class="list-rest__statistic-box"
                v-if="
                  (listDivide &&
                    listDivide[1] &&
                    index <
                      listDivide[0].numberOfSongs +
                        listDivide[1].numberOfSongs &&
                    indexOfStart) ||
                    indexOfStart && !special
                "
              >
                <div
                  tabindex="0"
                  :aria-label="'zmiana' + listItem.changeFromLastWeek"
                >
                  Zmiana
                </div>
                <p>{{ listItem.changeFromLastWeek }}</p>
                <div class="list-rest__symbol" v-if="indexOfStart">
                  <div
                    class="list-rest__symbol-up"
                    v-if="parseInt(listItem.changeFromLastWeek) > 0"
                  ></div>
                  <div
                    class="list-rest__symbol-zero"
                    v-if="parseInt(listItem.changeFromLastWeek) === 0"
                  ></div>
                  <div
                    class="list-rest__symbol-down"
                    v-if="parseInt(listItem.changeFromLastWeek) < 0"
                  ></div>
                </div>
              </div>

              <div
                class="list-rest__statistic-box"
                v-if="
                  (listDivide &&
                    index < listDivide[0].numberOfSongs &&
                    indexOfStart) ||
                    indexOfStart && !special 
                "
                
                tabindex="0"
                :aria-label="listItem.weeksOnList + 'raz na liście'"
              >
                <div v-if="top">{{ top }}</div>
                <p>{{ listItem.weeksOnList }}</p>
              </div>
              <ShareComponent
                :id="listItem.id"
                :name="listItem.name"
                v-if="mainList"
                class="mainShare"
              />
            </div>
          </div>
          <ShareComponent
            class="votingShare"
            :id="listItem.id"
            :name="listItem.name"
            v-if="!mainList"
          />
        </div>
        <div class="list-rest__button" v-if="!indexOfStart && canVote">
          <div class="list-rest__button-container" v-if="canVote">
            <SelectButton
              buttonName="wybierz"
              :action="
                () => {
                  addVote(listItem.id, listItem);
                }
              "
              v-if="
                !indexOfStart && !listItem.isAlreadyVoted && !listItem.voteAdded
              "
            />
            <SelectButton
              buttonName="wybrane"
              :action="() => {}"
              v-if="!indexOfStart && listItem.isAlreadyVoted"
            />
            <SelectButton
              buttonName="zagłosowane"
              :action="
                () => {
                  removeVote(listItem.id, listItem);
                }
              "
              v-if="
                !indexOfStart && !listItem.isAlreadyVoted && listItem.voteAdded
              "
            />
          </div>
        </div>
        <div class="list-rest__play">
          <i
            v-if="
              listItem.mp3Path !== '' &&
                listItem.mp3Path === actualPlay &&
                isPlaying
            "
            class="material-icons"
            @click="playMP3(listItem.mp3Path)"
            v-on:keyup.enter="playMP3(listItem.mp3Path)"
            tabindex="0"
            aria-label="Pauza"
          >
            pause_circle_outline
          </i>
          <i
            v-if="
              listItem.mp3Path !== '' &&
                listItem.mp3Path === actualPlay &&
                !isPlaying
            "
            class="material-icons"
            @click="playMP3(listItem.mp3Path)"
            v-on:keyup.enter="playMP3(listItem.mp3Path)"
            tabindex="0"
            aria-label="Odtówrz"
          >
            play_circle_outline
          </i>
          <i
            v-if="listItem.mp3Path !== '' && listItem.mp3Path !== actualPlay"
            class="material-icons"
            @click="playMP3(listItem.mp3Path)"
            v-on:keyup.enter="playMP3(listItem.mp3Path)"
            tabindex="0"
            aria-label="Odtwórz"
          >
            play_circle_outline
          </i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SelectButton from "@/ui/SelectButton.vue";
import VouteCounter from "@/ui/VoteCounter.vue";
import ShareComponent from "../../ShareComponent/ShareComponent";
import mixin from "../mixin";

export default {
  mixins: [mixin],
  props: ["mainList", "canVote"],
  components: {
    SelectButton,
    VouteCounter,
    ShareComponent
  }
};
</script>

<style scoped lang="scss">
.list-rest {
  &__list {
    &:hover {
      p.exceed {
        animation: scroll 7s linear infinite alternate;
      }
    }
  }
  .votingShare {
    margin-left: auto;
    align-self: center;
  }
  &__song-info {
    overflow: hidden;
  }
  &__single-list-element {
    width: 100%;
    height: 6.9rem;
    background-color: #fefefe;
    margin: 1.25rem 0;
    display: flex;
    border-radius: 5px;
    justify-content: space-between;
    &:not(.mainList) {
      height: 5rem;
    
      .list-rest__info-content {
        height: auto;
      }
      .list-rest__info {
        margin-top: 0;
        &-content {
          position: relative;
        }
      }
    }
    
  }
  
  &__index {
    height: 100%;
    min-width: 5rem;
    border-top-left-radius: 6px;
    border-bottom-left-radius: 6px;
    background-color: #efeeee;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #acacac;
    font-family: "Poppins", sans-serif;
    font-size: 2rem;
    font-weight: 700;
    &.voteAdded {
      background-color: #df2860;
      color: white;
    }
  }
  &__play {
    background-color: #eeeeee;
    display: flex;
    justify-content: center;
    align-items: center;
    min-width: 16%;
    border-top-right-radius: 6px;
    border-bottom-right-radius: 6px;
    color: #e22a60;
    cursor: pointer;
    border-left: 1px solid #d6d6d6;
    i {
      font-size: 3rem;
    }
  }
  &__photo {
    margin-left: 1.25rem;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  &__photo-content {
    width: 8.75rem;
    height: 5rem;
    box-sizing: border-box;
    border: 1px solid #e13368;
    position: relative;
    background-position: center;
    background-repeat: no-repeat;
    background-size: 100%;
  }
  &__photo-content-new {
    position: absolute;
    width: 3rem;
    height: 1rem;
    bottom: -0.5rem;
    left: 2.75rem;
    background-color: #41ae17;
    color: #fff;
    font-family: "Poppins", sans-serif;
    font-size: 0.55rem;
    text-transform: uppercase;
    font-weight: 500;
    display: flex;
    justify-content: center;
    align-items: center;
    &:before {
      content: "";
      width: 0;
      height: 0;
      position: absolute;
      left: -0.5rem;
      bottom: 0;
      border-top: 0.5rem solid #2e7114;
      border-left: 0.5rem solid transparent;
    }
    &:after {
      content: "";
      width: 0;
      height: 0;
      position: absolute;
      right: -0.5rem;
      bottom: 0;
      border-top: 0.5rem solid #2e7114;
      border-right: 0.5rem solid transparent;
    }
  }
  &__info {
    margin-left: 1.25rem;
    display: flex;
    width: 33%;
    align-items: center;
    margin-right: auto;
    height: 5rem;
    position: relative;
    margin-top: 0.95rem;
  }
  &__info-content {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    position: absolute;
    top: 0;
    &.mainList {
      height: 72%;
      width: 90%;
    }
    &.specialNote {
      flex-direction: row;
      width: 98% !important;
      .list-rest__song-info {
        overflow: visible;
      }
    }
  }
  &__info-artist {
    font-family: "Poppins", sans-serif;
    color: #0f1626;
    font-size: 1rem;
    line-height: 1.2;
    font-weight: 700;
    padding: 0 2rem 0.3rem 0;
    cursor: pointer;
    white-space: nowrap;
    width: 100%;
    height: 1rem;
    position: relative;
    @keyframes scroll {
      from {
        transform: translateX(0%);
      }
      to {
        transform: translateX(-50%);
      }
    }

    p {
      position: absolute;
      transform: translateX(0%);
      width: auto;
    }
  }
  &__info-title {
    font-family: "Poppins", sans-serif;
    font-size: 0.82rem;
    color: #0f1626;
    cursor: pointer;
    line-height: 1.2;
    white-space: nowrap;
    width: 100%;
    position: relative;
    height: 1rem;
    @keyframes scroll {
      from {
        transform: translateX(0%);
      }
      to {
        transform: translateX(-50%);
      }
    }
    p {
      position: absolute;
      width: auto;
    }
  }
  &__info-button {
    display: flex;
    align-items: center;
    position: absolute;
    bottom: -3rem;
    div {
      margin: 0 0.5rem 0 0;
    }
    i {
      color: #df2860;
      font-size: 2rem;
      cursor: pointer;
    }
  }
  &__info-button-social-media {
    width: 2rem;
    height: 2rem;
    background-image: url("/icons/media.png");
    background-position: center;
    background-repeat: no-repeat;
    background-size: 80%;
  }
  &__button {
    height: 100%;
    width: 11rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  &__button-container {
    height: 4.6875rem;
    width: 8.125rem;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    align-items: center;
  }
  &__button-statistic {
    display: flex;
    width: 100%;
  }
  &__statistic-box {
    display: flex;
    justify-content: space-around;
    align-items: center;
    border-right: 1px solid #ddd;
    width: 33%;
    padding-right: 0.5rem;
    height: 1rem;
    &:nth-last-child(3) {
      padding-right: 0.25rem;
    }
    &:nth-last-child(2) {
      border: none;
    }
    p {
      color: #0f1626;
      font-family: "Poppins", sans-serif;
      font-size: 0.8rem;
      font-weight: 700;
      margin: 0 0;
      margin-left: 0.5rem;
    }
    div {
      margin: 0 0;
      color: #0f1626;
      font-family: "Poppins", sans-serif;
      font-size: 0.65rem;
    }
  }
  &__symbol {
    display: flex;
    height: 1rem;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 1.5rem;
        margin-left: 0.5rem;
  }
  &__symbol-up {
    width: 0;
    height: 0;
    border-left: 0.5rem solid transparent;
    border-right: 0.5rem solid transparent;
    border-bottom: 0.7rem solid #4dc81d;
  }
  &__symbol-zero {
    width: 0.5rem;
    height: 0.5rem;
    background-color: #fbb101;
    border-radius: 100%;
  }
  &__symbol-down {
    width: 0;
    height: 0;
    border-left: 0.5rem solid transparent;
    border-right: 0.5rem solid transparent;
    border-top: 0.7rem solid #df2860;
  }
  &__waiting-room {
    font-size: 1.25rem;
    text-transform: uppercase;
    height: 2.5rem;
    font-weight: 700;
    font-family: "Poppins", sans-serif;
    display: flex;
    color: #fefefe;
    position: relative;
    margin-left: 1.5rem;
    align-items: center;
    color: #0f1626;
  }
  &__waiting-room:after {
    content: "";
    position: absolute;
    width: 1rem;
    height: 1rem;
    background-color: #df2860;
    left: -1.5rem;
  }
  .photoContentWithoutPhoto {
    background-image: url("/img/zaslepa.jpg") !important;
  }
  .secondFirst {
    background-color: #af2f82;
    background-image: linear-gradient(to top, #df2860, #5541bd);
  }
  .list-rest__info-button--waitingList {
    .list-rest__statistic-box {
    display: flex;
    justify-content: space-around;
    align-items: center;
    border-right: 1px solid #ddd;
    width: 33%;
    padding-right: 0.5rem;
    height: 1rem;
   
    &:nth-last-child(3) {
border: none    }
    &:nth-last-child(2) {
      display: none;
    }

    }}
}
.voted {
  .list-rest__index {
    background-color: #acacac;
    color: #ededed
  }
  .list-rest__info {
    opacity: 0.3;
  }
  .select-button {
    color:#d1cdcc;
    background: #ece6e6;
  }
}
</style>
